import React from "react"

function IconUserTimes({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="user-times"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-user-times"
      {...props}
    >
      <path
        d="M11.983 2.182c1.847 0 3.458.982 4.31 2.438l-.381.383-.128.138a2.168 2.168 0 0 0-.378.65c-.51-1.339-1.845-2.3-3.423-2.3-1.953 0-3.536 1.473-3.643 3.313l-.005.198v2.905c0 1.864 1.515 3.402 3.414 3.506l.205.006.203-.005c1.878-.084 3.365-1.529 3.469-3.308l.005-.199-.002-2.166a2.191 2.191 0 0 0 1.31.925l.001 1.241c0 1.29-.52 2.461-1.369 3.326l2.486.713a2.182 2.182 0 0 1 1.58 2.097v3.266a2.182 2.182 0 0 1-2.182 2.182H6.545a2.182 2.182 0 0 1-2.181-2.182v-3.26c0-.976.647-1.833 1.585-2.1l2.462-.7a4.735 4.735 0 0 1-1.386-3.342V7.002c0-2.662 2.22-4.82 4.958-4.82zm2.242 12.026c-.608.3-1.288.482-2.009.514l-.233.005a5.053 5.053 0 0 1-2.209-.503l-3.467.985a.873.873 0 0 0-.627.724l-.007.115v3.261c0 .445.333.812.763.866l.11.007h10.909a.873.873 0 0 0 .865-.763l.007-.11v-3.266a.873.873 0 0 0-.511-.794l-.12-.044-3.471-.997zm3.602-12.565.09.076 1.72 1.718 1.718-1.718a.655.655 0 0 1 1.002.835l-.076.09-1.718 1.72 1.718 1.719a.655.655 0 0 1-.835 1.001l-.09-.076-1.72-1.718-1.719 1.718a.655.655 0 0 1-1.001-.835l.076-.09 1.718-1.72-1.718-1.718a.655.655 0 0 1 .835-1.002z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconUserTimes
